import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import CallUsButton from './components/CallUsButton';
import { CurrencyContext } from 'day8-ui';
import TywMiniLogo from '../account/navbar/components/TywMiniLogo';
import YnfLogo from '../account/navbar/components/YnfLogo';
import history from '../../history';
import Dropdown from './components/Dropdown';
import FilterBar from '../Filters/FilterBar';
import { getSelectedWeeks } from '../../helpers/week';
import { useSelector } from 'react-redux';
import { supportedCurrencies } from '../../config';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useBookingBasket } from '../../context/BookingBasketContext';
import { Button } from 'day8-ui';
import { IoMdTime } from '@react-icons/all-files/io/IoMdTime';
import { MdOutlineArrowForward } from '@react-icons/all-files/md/MdOutlineArrowForward';
import BookingTimeout from '../booking/BookingTimeout';

const BookingNavbar = ({ isYachtsAndFriends }) => {
  const isFunnelYachtsRedirectFeature = useFeatureIsOn("custom-yachts-redirect");
  const { timeoutDateTime, currentBooking, isTimingOut } = useBookingBasket();
  const destinations = useSelector(state => state.destinations.items);
  const selectedWeek = getSelectedWeeks(destinations, history.location);
  const [hasOneSupportedCurrency, setHasOneSupportedCurrency] = useState(false);
  const [currentPath, setCurrentPath] = useState(history.location.pathname);
  const currencyContext = useContext(CurrencyContext);

  useEffect(() => {
    const unlisten = history.listen(location => {
      setCurrentPath(location.pathname);
    });
    return () => unlisten();
  }, []);

  useEffect(() => setHasOneSupportedCurrency(selectedWeek.length ? !!selectedWeek[0].fixedExchangeRate : false), [history.location, destinations]);
  useEffect(() => {
    if (hasOneSupportedCurrency && selectedWeek.length) {
      currencyContext.changeCurrency(selectedWeek[0].currency);
    }
  }, [hasOneSupportedCurrency]);
  const isVisible = true;
  const isPaymentPage = ['/booking/payment', '/booking/yachtsandfriends/payment'].includes(history.location.pathname);
  const shouldLinkHome = /^\/browse(\/yachts)?$/.test(currentPath) || (isYachtsAndFriends && /^\/browse\/yachtsandfriends(\/charter)?$/.test(currentPath));
  const linkHome = isYachtsAndFriends ? "https://www.yachtsandfriends.com" : "/";
  const logoLink = shouldLinkHome ? linkHome : `/browse${isYachtsAndFriends ? "/yachtsandfriends" : ""}${isFunnelYachtsRedirectFeature ? "/yachts" : ""}`;

  let logo = (
    <Link to={logoLink}>
      {isYachtsAndFriends ? <YnfLogo className="dui-text-black dui-w-[32px] md:dui-w-[64px] dui-h-[32px] md:dui-h-[64px]" /> : <TywMiniLogo className="dui-text-black dui-w-[32px] md:dui-w-[64px] dui-h-[32px] md:dui-h-[64px]" />}
    </Link>
  );
  if (shouldLinkHome) {
    logo = (
      <a href={logoLink}>
        {isYachtsAndFriends ? <YnfLogo className="dui-text-black dui-w-[32px] md:dui-w-[64px] dui-h-[32px] md:dui-h-[64px]" /> : <TywMiniLogo className="dui-text-black dui-w-[32px] md:dui-w-[64px] dui-h-[32px] md:dui-h-[64px]" />}
      </a>
    );
  }
  const shouldShowCheckout = timeoutDateTime && currentBooking;
  return (
    <div className={`${!shouldLinkHome ? "dui-hidden md:dui-block" : ""} dui-sticky dui-top-0 dui-bg-white dui-py-2 dui-z-10 dui-transition ${isVisible ? "" : "dui-translate-y-[-100%]"}`}>
      <div className='dui-flex dui-justify-between dui-items-center dui-gap-4 dui-container dui-mx-auto'>
        <div className={`md:dui-flex-1`}>
          {logo}
        </div>
        <div className={`dui-flex-grow dui-flex-1 dui-w-full dui-flex dui-justify-end md:dui-justify-center`}>
          {!shouldLinkHome && shouldShowCheckout && (
            <Button className='dui-shrink-0' disabled={isTimingOut} buttonSize='MEDIUM' buttonType={"LINK"} leftIcon={<IoMdTime />} rightIcon={!isPaymentPage && <MdOutlineArrowForward />} onClick={() => !isPaymentPage && history.push(isYachtsAndFriends ? '/booking/yachtsandfriends/payment' : '/booking/payment')} aria-label="Proceed to checkout">Checkout (<BookingTimeout />)</Button>
          )}
          {shouldLinkHome && (
            <FilterBar />
          )}
          {!shouldLinkHome && !shouldShowCheckout && <CallUsButton isYachtsAndFriends={isYachtsAndFriends} />}
        </div>
        <div className={`dui-hidden md:dui-flex md:dui-flex-1 md:dui-justify-end md:dui-shrink-0`}>
          <Dropdown supportedCurrencies={hasOneSupportedCurrency && selectedWeek.length ? [selectedWeek[0].currency] : supportedCurrencies} isYachtsAndFriends={isYachtsAndFriends} />
        </div>
      </div>
    </div>
  );
};

export default BookingNavbar;
